import React from "react";
import { environment, isDevelopment, isStaging } from "../../utils/Environment";

/**
 * EnvironmentBadge Component
 *
 * Displays a simple badge indicating the current environment (development or staging).
 * Only visible in non-production environments.
 */
const EnvironmentBadge: React.FC = () => {
  // Don't show anything in production
  if (!isDevelopment && !isStaging) {
    return null;
  }

  const getBadgeColor = () => {
    if (isDevelopment) {
      return "bg-blue-500 text-white";
    }
    if (isStaging) {
      return "bg-orange-500 text-white";
    }
    return "";
  };

  const getBadgeText = () => {
    if (isDevelopment) {
      return "LOCAL";
    }
    if (isStaging) {
      return "STAGING";
    }
    return "";
  };

  return (
    <div
      className={`px-2 py-1 rounded text-[10px] font-semibold tracking-wider uppercase ${getBadgeColor()}`}
      title={`Environment: ${environment}`}
    >
      {getBadgeText()}
    </div>
  );
};

export default EnvironmentBadge;
